import { bindable } from "aurelia";
import { parseSsn } from "../../common/ssn";

export class DeriveFromSsnCustomAttribute {
  @bindable ssn;
  @bindable form;

  binding() {
    this.recompute();
  }

  ssnChanged() {
    this.recompute();
  }

  recompute() {
    if (!this.form) return;
    const parsed = parseSsn(this.ssn);
    this.form.gender = parsed ? parsed.gender : "";
    this.form.age = parsed ? parsed.age : "";
  }
}
